/* NAV v2 — behaviour. CLICK-TO-OPEN only (no hover triggers). */
(function(){
  function init(root){
    if(!root || root.dataset.nv2Ready) return;
    root.dataset.nv2Ready="1";
    var trigs=[].slice.call(root.querySelectorAll('.nv2-trig'));
    var panels=[].slice.call(root.querySelectorAll('.nv2-panel'));
    var box=root.querySelector('.nv2-panels');
    var cur=-1;

    function open(i){
      cur=i;
      trigs.forEach(function(b,j){b.setAttribute('aria-expanded', j===i ? 'true':'false');});
      panels.forEach(function(p,j){p.classList.toggle('is-open', j===i);});
      if(box) box.classList.add('is-open');
    }
    function shut(){
      cur=-1;
      trigs.forEach(function(b){b.setAttribute('aria-expanded','false');});
      panels.forEach(function(p){p.classList.remove('is-open');});
      if(box) box.classList.remove('is-open');
    }

    trigs.forEach(function(b,i){
      /* click toggles. NO mouseenter handler — moving the pointer never opens
         or switches a panel, so dragging down through the bar is harmless. */
      b.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation();
        cur===i ? shut() : open(i);
      });
      b.addEventListener('keydown',function(e){
        var k=e.key;
        if(k==='ArrowRight'){e.preventDefault();trigs[(i+1)%trigs.length].focus();}
        else if(k==='ArrowLeft'){e.preventDefault();trigs[(i-1+trigs.length)%trigs.length].focus();}
        else if(k==='ArrowDown'){e.preventDefault();open(i);var f=panels[i]&&panels[i].querySelector('a');if(f)f.focus();}
        else if(k==='Escape'){shut();b.focus();}
        else if(k==='Enter'||k===' '){e.preventDefault();cur===i?shut():open(i);}
      });
    });

    /* close only on: outside click, Escape, or choosing a link. Never on mouseleave. */
    /* Outside click closes the panel and the click PASSES THROUGH, so clicking a
       product while a panel is open navigates on the first click. A previous
       version swallowed that click in the capture phase — it made clicking a
       product do nothing, which is worse than the misclick it was guarding. */
    document.addEventListener('click',function(e){ if(!root.contains(e.target)) shut(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') shut(); });

    var burger=root.querySelector('.nv2-burger'), draw=root.querySelector('.nv2-draw');
    if(burger&&draw){
      burger.addEventListener('click',function(){
        var o=draw.classList.toggle('is-open');
        burger.setAttribute('aria-expanded',o?'true':'false');
      });
    }
    [].slice.call(root.querySelectorAll('.nv2-abtn')).forEach(function(b){
      if(b.tagName!=='BUTTON') return;
      b.addEventListener('click',function(){
        var body=b.nextElementSibling, was=body.classList.contains('is-open');
        [].slice.call(root.querySelectorAll('.nv2-abody')).forEach(function(x){x.classList.remove('is-open');});
        [].slice.call(root.querySelectorAll('.nv2-abtn')).forEach(function(x){x.classList.remove('is-open');});
        if(!was){body.classList.add('is-open');b.classList.add('is-open');}
      });
    });
  }
  function boot(){ [].slice.call(document.querySelectorAll('[data-nav-v2]')).forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
